var styles = {
  "Item": "Online-Store-UI-Item_1mbsb",
  "Section": "Online-Store-UI-Item__Section_eiuey"
};

export { styles as default };
